import AppLightTooltip from './AppLightTooltip';
import AppSpacer from './AppSpacer';
import AppUseIcon from './AppUseIcon';

const AppPageHeader = ({
  title,
  tooltipContent = '',
  leftAlign = false,
  children,
}: {
  title: string;
  tooltipContent?: React.ReactNode;
  leftAlign?: boolean;
  children?: React.ReactNode;
}) => {
  return (
    <>
      <div className={`position-relative w-100 d-flex ${leftAlign ? '' : 'justify-content-center'}`}>
        <h1 className={`d-inline mb-0 font-25 text-uppercase${leftAlign ? '' : ' text-center'}`}>
          {title}
          {tooltipContent ? (
            <AppLightTooltip title={tooltipContent}>
              <AppUseIcon name='InfoIcon' className='ml-2' />
            </AppLightTooltip>
          ) : null}
        </h1>
        {children}
      </div>
      <AppSpacer space='34px' />
    </>
  );
};

export default AppPageHeader;
